import React from "react";
import OrderPage from "./components/OrderPage";
import { orderStatus } from "../../../constants/orderStatus";

const PreRegistered = () => {
  return <OrderPage type={orderStatus.preRegistered} />;
};

export default PreRegistered;
